module.exports = __webpack_public_path__ + "static/media/visa.0a3017e2.png";